import React from 'react';
import { motion } from 'framer-motion';
import { getApiBaseUrl } from '../../utils/apiUrl';

const EventHero = ({ event }) => {
  // Get hero image - prefer event_image, fallback to image_url
  const imageUrl = event.event_image || event.image_url || '/images/default-event.jpg';
  const fullImageUrl = imageUrl.startsWith('http') 
    ? imageUrl 
    : `${getApiBaseUrl()}${imageUrl}`;

  return (
    <div className="relative w-full h-[300px] md:h-[400px] lg:h-[500px] overflow-hidden">
      <motion.img
        src={fullImageUrl}
        alt={event.title_en || event.title || 'Event'}
        className="w-full h-full object-cover"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
        onError={(e) => {
          e.target.src = '/images/default-event.jpg';
        }}
      />
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white" />
    </div>
  );
};

export default EventHero;
